import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const EntityIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M12 6H6V26H12V28H6C4.89543 28 4 27.1046 4 26V6C4 4.89543 4.89543 4 6 4H12V6Z" />
    <path d="M26 4C27.1046 4 28 4.89543 28 6V26C28 27.1046 27.1046 28 26 28H20V26H26V6H20V4H26Z" />
    <path
      clipRule="evenodd"
      d="M15.4111 9.20312C15.8494 9.01602 16.3558 9.04756 16.7715 9.29688L21.2715 11.9971C21.7233 12.2681 22 12.7563 22 13.2832V18.7168C22 19.2437 21.7233 19.7318 21.2715 20.0029L16.7715 22.7031C16.2966 22.988 15.7034 22.988 15.2285 22.7031L10.7285 20.0029C10.2767 19.7318 10 19.2437 10 18.7168V13.2832C10 12.7563 10.2767 12.2681 10.7285 11.9971L15.2285 9.29688L15.4111 9.20312ZM12 13.5654V18.4336L16 20.834L20 18.4336V13.5654L16 11.165L12 13.5654Z"
      fillRule="evenodd"
    />
  </BaseIcon>
);
